/*******************************************************************
* PAGE        : DatePickerComponent
* REMARKS     : Comman DatePicker Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 11-03-2026
********************************************************************/
import React, { useState } from 'react';
import './DatePickerComponent.css';
import { Images } from '../../utils/Images';

const today = new Date().toISOString().split("T")[0];
const now = new Date().toISOString().slice(0, 16);

const DatePickerComponent = ({
    label,
    value,
    onChange,
    error,
    disabled = false,
    style = {},
    required = false,
    minDate = today,
    getTime = false,
    onFocus,
    onBlur,
    placeholder,
    ...props
}) => {

    const [focused, setFocused] = useState(false);

    // Convert time to 12h format
    const formatTime123h = (time) => {
        if (!time) return "";

        const [hour, minute] = time.split(":").map(Number);

        const period = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;

        return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
    };

    const formatTime12h = (time) => {
        if (!time) return "";

        const [hour, minute, second = "00"] = time.split(":").map(Number);

        const period = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;

        return `${hour12}:${minute.toString().padStart(2, "0")}:${second.toString().padStart(2, "0")} ${period}`;
    };

    const formatValue = (date) => {
        if (!date) return "";

        const d = new Date(date);

        if (isNaN(d.getTime())) return "";

        const pad = (n) => n.toString().padStart(2, "0");

        const year = d.getFullYear();
        const month = pad(d.getMonth() + 1);
        const day = pad(d.getDate());
        const hour = pad(d.getHours());
        const minute = pad(d.getMinutes());

        if (getTime) {
            return `${year}-${month}-${day}T${hour}:${minute}`;
        }

        return `${year}-${month}-${day}`;
    };
    const handleChange = (e) => {
        const val = e.target.value;
        if (getTime && val) {
            const [date, time] = val.split("T");
            const formattedTime12 = formatTime12h(time);
            onChange && onChange({
                raw: val,
                date: date,
                time24: time,
                time12: formattedTime12,
                fulldatetime: `${date}T${formattedTime12}`
            });

        } else {
            onChange && onChange(val);
        }
        // close picker
        // e.target.blur();
    };

    const handleFocus = (e) => {
        setFocused(true);
        onFocus?.(e);   // call parent if exists
    };

    const handleBlur = (e) => {
        setFocused(false);
        onBlur?.(e);    // call parent if exists
    };

    return (
        <div className="date-picker-container" style={style}>
            <label className="date-picker-label"> {label} </label>
            <div className={`date-picker-wrapper ${focused ? "focused" : ""}  ${error ? "error" : ""}${disabled ? "disabled" : ""}`}>

                <input
                    type={getTime ? "datetime-local" : "date"}
                    value={formatValue(value)}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    className="date-picker-input"
                    disabled={disabled}
                    min={getTime ? now : minDate}
                    // placeholder={placeholder || "dd-mm-yyyy"}
                    {...props}
                />
                <img
                    src={Images.calendar}
                    alt="calendar"
                    className="calendar-icon"
                />
            </div>
            {error && (
                <span className="error-text">
                    {error}
                </span>
            )}

        </div>
    );
};

export default DatePickerComponent;